var viewer_default = {
  "gallery_container": "EKq7b",
  "imageTitleContainer": "T8KsM",
  "clickableItem": "wQVs4",
  "prerender": "wE-z9",
  "expandButton": "w78te",
  "itemContainer": "PKWWb",
  "expandIcon": "xdhzu",
  "itemOverlay": "clRfT",
  "imageTitle": "D5N3Q",
  "pointer": "iz3XS",
  "fadeIn": "kZCCU",
  "changing_background": "IiFrV"
};
export {
  viewer_default as default
};
//# sourceMappingURL=viewer-scss.js.map
